import ApiClient from "./ApiClient";

export const login = ({ email, password }) => {
    return ApiClient.post('/api/auth/login', {
        email,
        password
    });
}

export const logout = ({ token }) => {
    return ApiClient.post('/api/auth/logout', {}, {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}

export const registerAgent = ({ token, data }) => {
    return ApiClient.post('/api/auth/register/agent', data, {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    })
}

export const registerAdmin = ({ token, data }) => {
    return ApiClient.post('/api/auth/register/admin', data, {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    })
}

export const update = ({ token, user, id }) => {
    return ApiClient.post('/api/auth/update/' + id, user, {
        headers: {
            'Authorization': 'Bearer ' + token,
            'content-type': 'multipart/form-data'
        }
    })
}

export const updatePassword = ({ token, user, id }) => {
    return ApiClient.post('/api/auth/update/' + id + '/update_password', user, {
        headers: {
            'Authorization': 'Bearer ' + token,
            'content-type': 'multipart/form-data'
        }
    })
}
